import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/heart-rate-recovery-calculator',
  component: () => import('../../routes/HeartRateRecoveryCalculator.svelte'),
  card: {
    id: 'heart-rate-recovery-calculator',
    title: 'Heart Rate Recovery Calculator',
    description:
      'Calculate your heart-rate recovery (HRR1 / HRR2) after peak exercise and see your estimated mortality-risk category based on the Cole (NEJM 1999) reference study. Includes Tanaka, Haskell–Fox, and Gulati age-predicted HRmax formulas.',
    icon: 'favorite',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/heart-rate-recovery-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title:
      'Heart Rate Recovery Calculator — HRR1 & HRR2 Mortality Risk (Cole 1999)',
    description:
      'Free heart-rate recovery calculator. Compute HRR1 (1-minute) and HRR2 (2-minute) recovery from a stress test or maximal-effort exercise, with rating, mortality-risk estimate, and HRmax prediction via Tanaka, Haskell–Fox, or Gulati formulas.',
  },
};

export default meta;